import React, { useState, useEffect } from "react";
import "./style.css";

import {
  MainNavBar,
  Footer,
  LineSeperator,
  TagsDisplay,
} from "../../UIcomponents/UiComponents";
import { LightBoxSimple } from "../../UIcomponents/lightboxsimple/LightBoxSimple";


import { Row, Col } from "antd";
import { IMAGE_BASE_URL } from "../../../services/api";

import { useQuery } from "react-query";
import opportunitiesRequests from "../../../services/helpers/opportunitiesquery";
import ReactHtmlParser, {
  processNodes,
  convertNodeToElement,
  htmlparser2,
} from "react-html-parser";

import { usePageHead } from "../../../common/UpdateMetaAndTitle";
import { metaFromRecord } from "../../../common/seoUtils";
import { withRouter } from "react-router";
import { formatDateWithFullYear } from "../../helper/formatDate";

// language context
import LocalizationContext from "../../../localization/LocalizationContext";

function PossibilitiesPage(props) {
  // i18n and current app language
  const { t, i18n } = React.useContext(LocalizationContext);
  const appLanguage = i18n.language;

  const { possibilityID } = props.match.params;

  // initial article language while page  loading
  let [articleLoadedLanguage, setArticleLoadedLanguage] = useState(null);

  const [imageListForLightBox, setImageListForLightBox] = useState([])
  const [toggle, setToggle] = useState(false);
  const [sIndex, setSIndex] = useState(0);

  // Handler
  const lightBoxHandler = (state, sIndex) => {
    setToggle(state);
    setSIndex(sIndex);
  };

  //getArtistByID from url
  let queryDataGetOpportunity = {
    resource: "opportunities",
    id: possibilityID,
  };
  const getPossibilityByIdQueryData = useQuery(
    ["getOpportunityById", queryDataGetOpportunity],
    () => opportunitiesRequests.getOpportunityById(queryDataGetOpportunity)
  );

  const _possibilityMeta = getPossibilityByIdQueryData.data
    ? metaFromRecord(getPossibilityByIdQueryData.data, "possibility")
    : { title: t("Possibilities") };
  usePageHead({ ..._possibilityMeta, path: props.location.pathname });

  // these use  effects are to get aleternate language article information
  // and then redirect to the page on change of langugage

  useEffect(() => {
    getPossibilityByIdQueryData.data &&
      setArticleLoadedLanguage(getPossibilityByIdQueryData.data.language);
  }, [getPossibilityByIdQueryData.data]);

  useEffect(() => {
    let _x = []
    getPossibilityByIdQueryData.data && getPossibilityByIdQueryData.data.imageOne &&
      _x.push(
        {
          "id": 0,
          "image": `${IMAGE_BASE_URL}${getPossibilityByIdQueryData.data.imageOne.url}`,
          "title": "",
          "description": ""
        }
      )

    getPossibilityByIdQueryData.data && getPossibilityByIdQueryData.data.imageTwo &&
      _x.push(
        {
          "id": 1,
          "image": `${IMAGE_BASE_URL}${getPossibilityByIdQueryData.data.imageTwo.url}`,
          "title": "",
          "description": ""
        }
      )

    getPossibilityByIdQueryData.data && getPossibilityByIdQueryData.data.imageThree &&
      _x.push(
        {
          "id": 2,
          "image": `${IMAGE_BASE_URL}${getPossibilityByIdQueryData.data.imageThree.url}`,
          "title": "",
          "description": ""
        }
      )

    setImageListForLightBox(_x)
  }, [getPossibilityByIdQueryData.data]);

  useEffect(() => {
    if (articleLoadedLanguage) {
      i18n.changeLanguage(articleLoadedLanguage)
    }
  }, [articleLoadedLanguage])

  useEffect(() => {
    let switchArticleId =
      getPossibilityByIdQueryData.data &&
      getPossibilityByIdQueryData.data.toggleLanguageWith &&
      getPossibilityByIdQueryData.data.toggleLanguageWith.id;

    let swtichArticleLanguage =
      getPossibilityByIdQueryData.data &&
      getPossibilityByIdQueryData.data.toggleLanguageWith &&
      getPossibilityByIdQueryData.data.toggleLanguageWith.language;

    if (!switchArticleId) return;
    if (swtichArticleLanguage && swtichArticleLanguage === appLanguage) {
      props.history.push(`/possibilities/${switchArticleId}`);
    }

  }, [appLanguage]);

  return (
    <>
      {getPossibilityByIdQueryData.isLoading && <p></p>}
      {getPossibilityByIdQueryData.data && (
        <>
          <MainNavBar
            backUrl="/possibilities"
            pageTitle={`${getPossibilityByIdQueryData.data.title.length > 15
              ? `${getPossibilityByIdQueryData.data.title.slice(0, 15)} (...)`
              : getPossibilityByIdQueryData.data.title
              }`}
            bgClass="bg-highlight"
          />
          <div className="content-container-wrapper bg-highlight">
            <div className="content-container-content">
              <>
                <Row className="possibilities_content-container">
                  <Col
                    xs={{ span: 24 }}
                    sm={{ span: 24 }}
                    md={{ span: 24 }}
                    lg={{ span: 9 }}
                    xl={{ span: 9 }}
                    xxl={{ span: 9 }}
                  >
                    <p className="possibilities_left_section-title fs-2-5em lh-1-2em">
                      {getPossibilityByIdQueryData.data.title}
                    </p>

                    <p className="possibilities_left_section-line fs-2-5em lh-1-2em">
                      {t("Application Deadline")}: <br />
                      {formatDateWithFullYear(getPossibilityByIdQueryData.data.applicationDeadline)}
                    </p>

                    <TagsDisplay
                      tagList={getPossibilityByIdQueryData.data.tags}
                    />

                    <div className="possibilities_left_section_images-large">
                      <div className="possibilities_left_section-seperator"></div>

                      <div className="possibilities_left_section_image">
                        {getPossibilityByIdQueryData.data.imageOne && (
                          <img
                            src={`${IMAGE_BASE_URL}${getPossibilityByIdQueryData.data.imageOne.url}`}
                            onClick={() => {
                              lightBoxHandler(true, 0);
                            }}
                          />
                        )}
                        <p className="possibilities_left_section_caption">
                          {getPossibilityByIdQueryData.data.imageOneCaption}
                        </p>
                      </div>

                      <div className="possibilities_left_section_image">
                        {getPossibilityByIdQueryData.data.imageTwo && (
                          <img
                            src={`${IMAGE_BASE_URL}${getPossibilityByIdQueryData.data.imageTwo.url}`}
                            onClick={() => {
                              lightBoxHandler(true, 1);
                            }}
                          />
                        )}
                        <p className="possibilities_left_section_caption">
                          {getPossibilityByIdQueryData.data.imageTwoCaption}
                        </p>
                      </div>

                      <div className="possibilities_left_section_image">
                        {getPossibilityByIdQueryData.data.imageThree && (
                          <img
                            src={`${IMAGE_BASE_URL}${getPossibilityByIdQueryData.data.imageThree.url}`}
                            onClick={() => {
                              lightBoxHandler(true, 2);
                            }}
                          />
                        )}
                        <p className="possibilities_left_section_caption">
                          {getPossibilityByIdQueryData.data.imageThreeCaption}
                        </p>
                      </div>
                    </div>
                    {/* lightbox for carousel */}
                    <LightBoxSimple
                      toggle={toggle}
                      lightBoxHandler={lightBoxHandler}
                      data={imageListForLightBox}
                      sIndex={sIndex}
                      setSIndex={setSIndex}
                    />
                  </Col>
                  <Col
                    xs={{ span: 24 }}
                    sm={{ span: 24 }}
                    md={{ span: 24 }}
                    lg={{ span: 3 }}
                    xl={{ span: 3 }}
                    xxl={{ span: 3 }}
                  ></Col>
                  <Col
                    xs={{ span: 24 }}
                    sm={{ span: 24 }}
                    md={{ span: 24 }}
                    lg={{ span: 12 }}
                    xl={{ span: 12 }}
                    xxl={{ span: 12 }}
                  >
                    <div className="possibilities_right_section">
                      <p className="possibilities_right_section-title  fs-2-5em lh-1-2em">
                        {
                       // t("About the project")
                        }
                      </p>
                      <div className="possibilities_right_section-description">
                        <div className="ck-content">
                          {ReactHtmlParser(
                            getPossibilityByIdQueryData.data.aboutProject
                          )}
                        </div>
                      </div>

                      <p className="possibilities_right_section-title  fs-2-5em lh-1-2em">
                        {t("Technical Information")}
                      </p>
                      <div className="possibilities_right_section-description">
                        <div className="ck-content">
                          {ReactHtmlParser(
                            getPossibilityByIdQueryData.data.technicalInfo
                          )}
                        </div>
                      </div>
                      <p className="possibilities_right_section-title  fs-2-5em lh-1-2em">
                        {t("Contact Information")}
                      </p>
                      <div className="possibilities_right_section-description">
                        <div className="ck-content">
                          {ReactHtmlParser(
                            getPossibilityByIdQueryData.data.contactInfo
                          )}
                        </div>
                      </div>
                    </div>
                  </Col>
                  <Col
                    xs={{ span: 24 }}
                    sm={{ span: 24 }}
                    md={{ span: 24 }}
                    lg={{ span: 9 }}
                    xl={{ span: 9 }}
                    xxl={{ span: 9 }}
                  >
                    <div className="possibilities_left_section_images-small">
                      <div className="possibilities_left_section-seperator"></div>

                      <div className="possibilities_left_section_image">
                        {getPossibilityByIdQueryData.data.imageOne && (
                          <img
                            src={`${IMAGE_BASE_URL}${getPossibilityByIdQueryData.data.imageOne.url}`}
                          />
                        )}
                        <p className="possibilities_left_section_caption">
                          {getPossibilityByIdQueryData.data.imageOneCaption}
                        </p>
                      </div>

                      <div className="possibilities_left_section_image">
                        {getPossibilityByIdQueryData.data.imageTwo && (
                          <img
                            src={`${IMAGE_BASE_URL}${getPossibilityByIdQueryData.data.imageTwo.url}`}
                          />
                        )}
                        <p className="possibilities_left_section_caption">
                          {getPossibilityByIdQueryData.data.imageTwoCaption}
                        </p>
                      </div>

                      <div className="possibilities_left_section_image">
                        {getPossibilityByIdQueryData.data.imageThree && (
                          <img
                            src={`${IMAGE_BASE_URL}${getPossibilityByIdQueryData.data.imageThree.url}`}
                          />
                        )}
                        <p className="possibilities_left_section_caption">
                          {getPossibilityByIdQueryData.data.imageThreeCaption}
                        </p>
                      </div>
                    </div>
                  </Col>
                </Row>
              </>
            </div>
          </div>
          <LineSeperator />
          <Footer />
        </>
      )}
    </>
  );
}

export default withRouter(PossibilitiesPage);
